/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'
import { withFormik } from 'formik'
const Yup = require('yup')

/**
 *     Import
 *     - Components
 */
import { Button } from '../../../common/Button/Button'
import { Alert } from '../../../common/Alert/Alert'
import Checkbox from '../../../common/Checkbox/Checkbox'
import ToolTip from '../../../common/ToolTip/ToolTip'

/**
 *     Import
 *     - CSS
 */
import '../styles/Step04.css'

/**
 * Step04 class {/quote/:qouteId/Step04}
 *
 * @class Step04FormHTML
 * @extends {React.Component<any, any>}
 */
class Step04FormHTML extends React.Component<any, any> {

    /**
     * Creates an instance of Step04FormHTML.
     *
     * @param {*} props
     * @memberof Step04FormHTML
     */
    constructor(props: any) {
        super(props)

        let { data, editQuote } = this.props

        this.state = {
            formData: {
                transitExibitions: {
                    outsideLimit: {
                        check: (editQuote && data.outsideLimit > 0) ? true : false,
                        value: editQuote && data.outsideLimit !== null ? data.outsideLimit : Number(),
                    },
                    sumInsured: {
                        check: (editQuote && data.sumInsured > 0) ? true : false,
                        value: editQuote && data.sumInsured !== null ? data.sumInsured : Number(),
                        anualAggregateEstimates: {
                            tradeFairsWithinUk: editQuote ? data.tradeFairsWithinUk : Number(),
                            tradeFairsOutsideUk: editQuote ? data.tradeFairsOutsideUk : Number(),
                            numberOfTradeFairs: editQuote ? data.numberOfTradeFairs : Number(),
                            ukOutideAtLEastOne: Number(0),
                        },
                    },
                },
                extraInsuranceCover: {
                    buildings: {
                        check: (editQuote && data.buildings > 0) ? true : false,
                        value: editQuote && data.buildings !== null ? data.buildings : Number(),
                    },
                    officeContentsTenantsImprovements: {
                        check: (editQuote && data.officeContentsTenantsImprovements > 0) ? true : false,
                        value: editQuote && data.officeContentsTenantsImprovements !== null ?
                            data.officeContentsTenantsImprovements : Number(),
                    },
                    laptopsCamerasBusinessMachines: {
                        check: (editQuote && data.laptopsCamerasBusinessMachines > 0) ? true : false,
                        value: editQuote && data.laptopsCamerasBusinessMachines !== null ?
                            data.laptopsCamerasBusinessMachines : Number(),
                    },
                    staticComputerEquipment: {
                        check: (editQuote && data.staticComputerEquipment > 0) ? true : false,
                        value: editQuote && data.staticComputerEquipment !== null ?
                            data.staticComputerEquipment : Number(),
                    },
                    publicLiability: {
                        check: (editQuote && data.publicLiability > 0) ? true : false,
                        selection: (editQuote && data.publicLiability !== null) ? data.publicLiability : 2,
                    },
                    employerLiabilityWageroll: {
                        check: (editQuote && data.employerLiabilityWageroll > 0) ? true : false,
                        value: editQuote && data.employerLiabilityWageroll !== null ?
                            data.employerLiabilityWageroll : Number(),
                    },
                    ernNumber: {
                        value: editQuote && data.ernNumber !== null ? data.ernNumber : Number(),
                    },
                    employerLiabilityType: {
                        selection: editQuote && data.employerLiabilityType !== null ?
                            data.employerLiabilityType : 'Enter ERN number',
                    },
                    businessInterruption: {
                        check: (editQuote && data.businessInterruption > 0) ? true : false,
                        value: editQuote && data.businessInterruption !== null ? data.businessInterruption : Number(),
                    },
                    businessInterruptionDuration: {
                        selection: editQuote ? data.businessInterruptionDuration : 12,
                    },
                    aicow: {
                        check: (editQuote && data.aicow > 0) ? true : false,
                        value: editQuote && data.aicow !== null ? data.aicow : Number(),
                    },
                    sicow: {
                        check: (editQuote && data.sicow > 0) ? true : false,
                        value: editQuote && data.sicow !== null ? data.sicow : Number(),
                    },
                },
            },
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    /**
     * Reset all quote data before going to next step
     *
     * @memberof Step04FormHTML
     */
    componentWillUnmount() {
        if (this.props.resetQuotes) {
            this.props.resetQuotes()
        }
    }

    /**
     * Handle the checkbox state, update the class state and the
     * Formik values
     *
     * @param {*} state     the actual state of the checkbox
     * @param {*} name      the checkbox triggered
     * @memberof Step04FormHTML
     */
    handleCheckbox = (state: any, name: any) => {
        this.updateStateObject(name, state)

        if (name === 'extraInsuranceCover.publicLiability.check') {
            this.updateFormikValues(
                'extraInsuranceCover.publicLiability.selection',
                this.state.formData.extraInsuranceCover.publicLiability.selection
            )

        } else if (name === 'extraInsuranceCover.employerLiabilityWageroll.check') {
            this.
                updateFormikValues(
                    'extraInsuranceCover.employerLiabilityWageroll.value',
                    this.state.formData.extraInsuranceCover.employerLiabilityWageroll.value
                )

            this.updateFormikValues(
                'extraInsuranceCover.ernNumber.selection',
                this.state.formData.extraInsuranceCover.ernNumber.selection
            )

            this.updateFormikValues(
                'extraInsuranceCover.ernNumber.value',
                this.state.formData.extraInsuranceCover.ernNumber.value
            )

        } else if (name === 'extraInsuranceCover.businessInterruption.check') {
            this.updateFormikValues(
                'extraInsuranceCover.businessInterruption.value',
                this.state.formData.extraInsuranceCover.businessInterruption.value
            )

            this.updateFormikValues(
                'extraInsuranceCover.businessInterruptionDuration.selection',
                this.state.formData.extraInsuranceCover.businessInterruptionDuration.selection
            )
        }
    }

    /**
     * Changes focus between the different buttons inside the items
     *
     * @param {string}  targetSwitch    the switch clicked
     * @param {*}       value           the state of that button
     * @memberof Step04FormHTML
     */
    changeSwitch = (targetSwitch: string, value: any) => this.updateStateObject(targetSwitch, value)

    /**
     * Updates the state of the class with the new value
     *
     * @param {*} item  the item to update
     * @param {*} value the value of the item
     * @memberof Step04FormHTML
     */
    updateStateObject = (item: any, value: any) => {
        let newStateItem = this.state.formData
        let listKeys = item.split('.')

        if (listKeys.length <= 3) {
            newStateItem[listKeys[0]][listKeys[1]][listKeys[2]] = value
        } else {
            newStateItem[listKeys[0]][listKeys[1]][listKeys[2]][listKeys[3]] = value
        }

        if (item === 'transitExibitions.sumInsured.anualAggregateEstimates.tradeFairsWithinUk') {
            if (this.state.formData.transitExibitions.sumInsured.anualAggregateEstimates.tradeFairsOutsideUk > 0
                && value > 0) {
                newStateItem.transitExibitions.sumInsured.anualAggregateEstimates.ukOutideAtLEastOne = 3
                this.updateFormikValues('transitExibitions.sumInsured.anualAggregateEstimates.ukOutideAtLEastOne', 3)

            } else if (this.state.formData.transitExibitions.sumInsured.anualAggregateEstimates.tradeFairsOutsideUk > 0
                && value === 0) {
                newStateItem.transitExibitions.sumInsured.anualAggregateEstimates.ukOutideAtLEastOne = 2
                this.updateFormikValues('transitExibitions.sumInsured.anualAggregateEstimates.ukOutideAtLEastOne', 2)
            } else if (
                this.state.formData.transitExibitions.sumInsured.anualAggregateEstimates.tradeFairsOutsideUk === 0
                && value > 0
            ) {
                newStateItem.transitExibitions.sumInsured.anualAggregateEstimates.ukOutideAtLEastOne = 1
                this.updateFormikValues('transitExibitions.sumInsured.anualAggregateEstimates.ukOutideAtLEastOne', 1)
            } else {
                newStateItem.transitExibitions.sumInsured.anualAggregateEstimates.ukOutideAtLEastOne = 0
                this.updateFormikValues('transitExibitions.sumInsured.anualAggregateEstimates.ukOutideAtLEastOne', 0)
            }
        }

        if (item === 'transitExibitions.sumInsured.anualAggregateEstimates.tradeFairsOutsideUk') {

            if (this.state.formData.transitExibitions.sumInsured.anualAggregateEstimates.tradeFairsWithinUk > 0
                && value > 0) {
                newStateItem.transitExibitions.sumInsured.anualAggregateEstimates.ukOutideAtLEastOne = 3
                this.updateFormikValues('transitExibitions.sumInsured.anualAggregateEstimates.ukOutideAtLEastOne', 3)

            } else if (this.state.formData.transitExibitions.sumInsured.anualAggregateEstimates.tradeFairsWithinUk > 0
                && value === 0) {
                newStateItem.transitExibitions.sumInsured.anualAggregateEstimates.ukOutideAtLEastOne = 1
                this.updateFormikValues('transitExibitions.sumInsured.anualAggregateEstimates.ukOutideAtLEastOne', 1)
            } else if (this.state.formData.transitExibitions.sumInsured.anualAggregateEstimates.tradeFairsWithinUk === 0
                && value > 0) {
                newStateItem.transitExibitions.sumInsured.anualAggregateEstimates.ukOutideAtLEastOne = 2
                this.updateFormikValues('transitExibitions.sumInsured.anualAggregateEstimates.ukOutideAtLEastOne', 2)
            } else {
                newStateItem.transitExibitions.sumInsured.anualAggregateEstimates.ukOutideAtLEastOne = 0
                this.updateFormikValues('transitExibitions.sumInsured.anualAggregateEstimates.ukOutideAtLEastOne', 0)
            }
        }

        this.setState({
            formData: newStateItem,
        })
        this.updateFormikValues(item, value)
    }

    /**
     * Updates the Formik values
     *
     * @param {*} item  the item to update
     * @param {*} value the value to update
     * @memberof Step04FormHTML
     */
    updateFormikValues = (item: any, value: any) => {
        let listKeys = item.split('.')
        if (listKeys.length <= 3) {
            this.props.values[
                listKeys[listKeys.length - 2] + (
                    (listKeys[listKeys.length - 1] === 'check') ?
                        'Check'
                        : ''
                )
            ] = value
        } else {
            this.props.values[listKeys[listKeys.length - 1]] = value
        }

        let test = listKeys[listKeys.length - 2] + (
            (listKeys[listKeys.length - 1] === 'check') ?
                'Check'
                : ''
        )

        // this.props.setFieldValue(test, value)
        this.props.setFieldTouched(test, true)
    }

    inputClick = (item) => {
        let newStateItem = this.state.formData
        let listKeys = item.split('.')

        // console.log(newStateItem[listKeys[0]][listKeys[1]][listKeys[2]])
        // console.log(newStateItem[listKeys[0]][listKeys[1]][listKeys[2]][listKeys[3]])
        if (listKeys.length <= 3) {
            newStateItem[listKeys[0]][listKeys[1]][listKeys[2]] = true
        } else {
            newStateItem[listKeys[0]][listKeys[1]][listKeys[2]][listKeys[3]] = true
        }
        this.setState({ formData: newStateItem })
    }

    render() {

        const {
            handleSubmit,
            quote,
        } = this.props

        let {
            transitExibitions,
            extraInsuranceCover,
        } = this.state.formData

        let errorList: any[] = []

        let errorState: any = null // Fake errorState for test proposes
        if (errorState !== null) { errorList.push(errorState._data) }

        if (quote.step04.done && !this.props.editQuote) {
            this.props.history.push('/quote/' + this.props.match.params.id + '/step05')
        }
        if (this.props.updateDirty) {
            this.props.dirty ? this.props.updateDirty(true) : this.props.updateDirty(false)
        }

        return (
            <div className="step04">
                {(!!Object.keys(this.props.errors).length && !!Object.keys(this.props.touched).length) && (
                    Object.keys(this.props.errors).filter(
                        (msg) => Object.keys(this.props.touched).includes(msg)
                    ).map((error, idx) => {
                        const msg = this.props.errors[error]
                        errorList.push(`${msg.charAt(0).toUpperCase()}${msg.slice(1)}`)
                    })
                )}

                {(errorList.length) ? (
                    <Alert type="error">
                        {errorList.map((a, i) => (<p key={i}>{a}</p>))}
                    </Alert>
                ) : null}

                {(quote.step04.error) ? (
                    <Alert type="error">
                        Error: something went wrong please contact support
                    </Alert>
                ) : null}

                <form className="step04Form quote__form cust_class" onSubmit={handleSubmit}>

                    <div className="group">
                        <div className="title">
                            <h4>Transit & exhibitions</h4>
                        </div>
                        <div className="item-col-2 item-col-2__w58 bottom-line">
                            <div className="col1 col1__checkbox">
                                <Checkbox
                                    last={true}
                                    first={true}
                                    short={true}
                                    name="transitExibitions.outsideLimit.check"
                                    selected={transitExibitions.outsideLimit.check}
                                    onChange={this.handleCheckbox}
                                >
                                    Outside limit
                                </Checkbox>
                                <ToolTip position="left">
                                    The maximum any one loss whilst in transit anywhere Worldwide &/or whilst entrusted
                                    to third parties &/or in storage &/or at restorers &/or at framers &/or at auction
                                    houses &/or at any other unnamed location anywhere worldwide but Limited to GBP
                                    10,000 in respect of any sending by Post, Registered Post, Recorded Delivery,
                                    Insured Parcel Post etc.
                                </ToolTip>
                            </div>
                            <div className="col2">
                                <div
                                    className={`input ${!(transitExibitions.outsideLimit.check) ? `disabled` : ``}`}
                                    onClick={() => this.inputClick('transitExibitions.outsideLimit.check')}
                                >
                                    <div className="pound">
                                        &pound;
                                    </div>
                                    <input
                                        name="outsideLimit"
                                        placeholder="0"
                                        disabled={!transitExibitions.outsideLimit.check}
                                        onChange={
                                            (event) => {
                                                this.updateStateObject(
                                                    'transitExibitions.outsideLimit.value',
                                                    Number(event.target.value)
                                                )
                                            }
                                        }
                                        type="number"
                                        min="0"
                                        step="any"
                                        value={transitExibitions.outsideLimit.value.toString().replace(/^0+/, '')}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="item-col-2 item-col-2__w58 shadow">
                            <div className="col1 col1__checkbox">
                                <Checkbox
                                    last={true}
                                    first={true}
                                    short={true}
                                    name="transitExibitions.sumInsured.check"
                                    selected={transitExibitions.sumInsured.check}
                                    onChange={this.handleCheckbox}
                                >
                                    Trade Fairs
                                </Checkbox>
                                <ToolTip position="left">
                                    The maximum any one loss whilst exhibiting at Trade Fairs worldwide including the
                                    transit to and from the fair but Limited to GBP 10,000 in respect of any sending by
                                    Post, Registered Post, Recorded Delivery, Insured Parcel Post etc.
                                </ToolTip>
                            </div>
                        </div>
                        <div className={`item-group ${!(transitExibitions.sumInsured.check) ? `hidden` : ``}`}>
                            <span>Please enter annual aggregate estimates for the following:</span>
                            <div className="input-group">
                                <div className="input-group__left">
                                    <label>Trade fairs within the UK</label>
                                    <div
                                        className="input"
                                        onClick={() => this.inputClick('transitExibitions.sumInsured.check')}
                                    >
                                        <div className="pound">
                                            &pound;
                                    </div>
                                        <input
                                            name="tradeFairsWithinUk"
                                            placeholder="0"
                                            onChange={
                                                (event) => {
                                                    this.updateStateObject(
                                                        'transitExibitions.sumInsured.' +
                                                        'anualAggregateEstimates.tradeFairsWithinUk',
                                                        Number(event.target.value)
                                                    )
                                                }
                                            }
                                            type="number"
                                            min="0"
                                            step="any"
                                            value={
                                                transitExibitions.sumInsured.anualAggregateEstimates.tradeFairsWithinUk
                                                    .toString().replace(/^0+/, '')
                                            }
                                        />
                                    </div>
                                    <label>Number of trade fairs</label>
                                    <div className="input input__no-symbol">
                                        <input
                                            name="numberOfTradeFairs"
                                            onChange={
                                                (event) => {
                                                    this.updateStateObject(
                                                        'transitExibitions.sumInsured.' +
                                                        'anualAggregateEstimates.numberOfTradeFairs',
                                                        Number(event.target.value)
                                                    )
                                                }
                                            }
                                            type="number"
                                            min="0"
                                            step="any"
                                            value={
                                                transitExibitions.sumInsured.anualAggregateEstimates.numberOfTradeFairs
                                                    .toString().replace(/^0+/, '')
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="input-group__right">
                                    <label>Trade fairs outside the UK</label>
                                    <div className="input">
                                        <div className="pound">
                                            &pound;
                                    </div>
                                        <input
                                            name="tradeFairsOutsideUk"
                                            onChange={
                                                (event) => {
                                                    this.updateStateObject(
                                                        'transitExibitions.sumInsured.' +
                                                        'anualAggregateEstimates.tradeFairsOutsideUk',
                                                        Number(event.target.value)
                                                    )
                                                }
                                            }
                                            placeholder="0"
                                            type="number"
                                            min="0"
                                            step="any"
                                            value={
                                                transitExibitions.sumInsured.anualAggregateEstimates.tradeFairsOutsideUk
                                                    .toString().replace(/^0+/, '')
                                            }
                                        />
                                    </div>
                                    <label>Maximum cover value</label>
                                    <div className={`input ${!(transitExibitions.sumInsured.check) ? `disabled` : ``}`}>
                                        <div className="pound">
                                            &pound;
                                    </div>
                                        <input
                                            name="sunInsured"
                                            disabled={!transitExibitions.sumInsured.check}
                                            placeholder="0"
                                            onChange={
                                                (event) => {
                                                    this.updateStateObject(
                                                        'transitExibitions.sumInsured.value',
                                                        Number(event.target.value)
                                                    )
                                                }
                                            }
                                            type="number"
                                            min="0"
                                            step="any"
                                            value={transitExibitions.sumInsured.value.toString().replace(/^0+/, '')}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="separator" />

                    <div className="group">
                        <div className="title">
                            <h4>Add extra insurance cover</h4>
                        </div>
                        <div className="item-col-2 item-col-2__w58 item-col-2 item-col-2__title-name">
                            <div className="col1">
                                <span>Type of cover</span>
                            </div>
                            <div className="col2">
                                <span>Sum insured</span>
                            </div>
                        </div>
                        <div className="item-col-2 item-col-2__w58 bottom-line">
                            <div className="col1 col1__checkbox">
                                <Checkbox
                                    last={true}
                                    first={true}
                                    short={true}
                                    name="extraInsuranceCover.buildings.check"
                                    selected={extraInsuranceCover.buildings.check}
                                    onChange={this.handleCheckbox}
                                >
                                    Buildings
                                </Checkbox>
                            </div>
                            <div className="col2">
                                <div
                                    className={`input ${!(extraInsuranceCover.buildings.check) ? `disabled` : ``}`}
                                    onClick={() => this.inputClick('extraInsuranceCover.buildings.check')}
                                >
                                    <div className="pound">
                                        &pound;
                                    </div>
                                    <input
                                        name="buildings"
                                        disabled={!extraInsuranceCover.buildings.check}
                                        onChange={
                                            (event) => {
                                                this.updateStateObject(
                                                    'extraInsuranceCover.buildings.value',
                                                    Number(event.target.value)
                                                )
                                            }
                                        }
                                        placeholder="0"
                                        type="number"
                                        min="0"
                                        step="any"
                                        value={extraInsuranceCover.buildings.value.toString().replace(/^0+/, '')}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="item-col-2 item-col-2__w58 bottom-line">
                            <div className="col1 col1__checkbox">
                                <Checkbox
                                    last={true}
                                    first={true}
                                    short={true}
                                    name="extraInsuranceCover.officeContentsTenantsImprovements.check"
                                    selected={extraInsuranceCover.officeContentsTenantsImprovements.check}
                                    onChange={this.handleCheckbox}
                                >
                                    Office contents & tenants improvements
                                </Checkbox>
                            </div>
                            <div className="col2">
                                <div
                                    className={`input ${!(extraInsuranceCover.officeContentsTenantsImprovements.check) ?
                                        `disabled` :
                                        ``}`}
                                    onClick={() =>
                                        this.inputClick('extraInsuranceCover.officeContentsTenantsImprovements.check')
                                    }
                                >
                                    <div className="pound">
                                        &pound;
                                    </div>
                                    <input
                                        name="officeContentsTenantsImprovements"
                                        disabled={!extraInsuranceCover.officeContentsTenantsImprovements.check}
                                        placeholder="0"
                                        onChange={
                                            (event) => {
                                                this.updateStateObject(
                                                    'extraInsuranceCover.' +
                                                    'officeContentsTenantsImprovements.value',
                                                    Number(event.target.value)
                                                )
                                            }
                                        }
                                        type="number"
                                        min="0"
                                        step="any"
                                        value={extraInsuranceCover.officeContentsTenantsImprovements.value.toString()
                                            .replace(/^0+/, '')}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="item-col-2 item-col-2__w58 bottom-line">
                            <div className="col1 col1__checkbox">
                                <Checkbox
                                    last={true}
                                    first={true}
                                    short={true}
                                    name="extraInsuranceCover.laptopsCamerasBusinessMachines.check"
                                    selected={extraInsuranceCover.laptopsCamerasBusinessMachines.check}
                                    onChange={this.handleCheckbox}
                                >
                                    Laptops / cameras / business machines (all risks)
                                </Checkbox>
                            </div>
                            <div className="col2">
                                <div
                                    className={`input ${!(extraInsuranceCover.laptopsCamerasBusinessMachines.check) ?
                                        `disabled` :
                                        ``}`}
                                    onClick={() =>
                                        this.inputClick('extraInsuranceCover.laptopsCamerasBusinessMachines.check')
                                    }
                                >
                                    <div className="pound">
                                        &pound;
                                    </div>
                                    <input
                                        name="laptopsCamerasBusinessMachines"
                                        disabled={!extraInsuranceCover.laptopsCamerasBusinessMachines.check}
                                        onChange={
                                            (event) => {
                                                this.updateStateObject(
                                                    'extraInsuranceCover.' +
                                                    'laptopsCamerasBusinessMachines.value',
                                                    Number(event.target.value)
                                                )
                                            }
                                        }
                                        placeholder="0"
                                        type="number"
                                        min="0"
                                        step="any"
                                        value={extraInsuranceCover.laptopsCamerasBusinessMachines.value.toString()
                                            .replace(/^0+/, '')}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="item-col-2 item-col-2__w58 bottom-line">
                            <div className="col1 col1__checkbox">
                                <Checkbox
                                    last={true}
                                    first={true}
                                    short={true}
                                    name="extraInsuranceCover.staticComputerEquipment.check"
                                    selected={extraInsuranceCover.staticComputerEquipment.check}
                                    onChange={this.handleCheckbox}
                                >
                                    Static computer equipment
                                </Checkbox>
                            </div>
                            <div className="col2">
                                <div
                                    className={`input ${!(extraInsuranceCover.staticComputerEquipment.check) ?
                                        `disabled` :
                                        ``}`}
                                    onClick={() =>
                                        this.inputClick('extraInsuranceCover.staticComputerEquipment.check')
                                    }
                                >
                                    <div className="pound">
                                        &pound;
                                    </div>
                                    <input
                                        name="staticComputerEquipment"
                                        disabled={!extraInsuranceCover.staticComputerEquipment.check}
                                        placeholder="0"
                                        onChange={
                                            (event) => {
                                                this.updateStateObject(
                                                    'extraInsuranceCover.' +
                                                    'staticComputerEquipment.value',
                                                    Number(event.target.value)
                                                )
                                            }
                                        }
                                        type="number"
                                        min="0"
                                        step="any"
                                        value={extraInsuranceCover.staticComputerEquipment.value.toString()
                                            .replace(/^0+/, '')}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="item-col-2 item-col-2__w58 bottom-line">
                            <div className="col1 col1__checkbox">
                                <Checkbox
                                    last={true}
                                    first={true}
                                    short={true}
                                    name="extraInsuranceCover.publicLiability.check"
                                    selected={extraInsuranceCover.publicLiability.check}
                                    onChange={this.handleCheckbox}
                                >
                                    Public Liability
                                </Checkbox>
                            </div>
                            <div className="col2">
                                <div className="switchies">
                                    <div
                                        className={`switch
                                        ${(extraInsuranceCover.publicLiability.selection === 2
                                                && extraInsuranceCover.publicLiability.check) ?
                                                `selected` :
                                                ``}
                                        ${!(extraInsuranceCover.publicLiability.check) ? ' disabled' : ''}`}
                                        onClick={() => {
                                            if (extraInsuranceCover.publicLiability.check) {
                                                this.changeSwitch('extraInsuranceCover.publicLiability.selection', 2)
                                                this.updateStateObject(
                                                    'extraInsuranceCover.' +
                                                    'publicLiability.selection',
                                                    Number(2)
                                                )
                                            }
                                        }}
                                    >
                                        &pound;2M
                                    </div>
                                    <div
                                        className={`switch
                                        ${(extraInsuranceCover.publicLiability.selection === 5 &&
                                                extraInsuranceCover.publicLiability.check) ?
                                                `selected` :
                                                ``}
                                        ${!(extraInsuranceCover.publicLiability.check) ? ' disabled' : ''}`}
                                        onClick={() => {
                                            if (extraInsuranceCover.publicLiability.check) {
                                                this.changeSwitch('extraInsuranceCover.publicLiability.selection', 5)
                                                this.updateStateObject(
                                                    'extraInsuranceCover.' +
                                                    'publicLiability.selection',
                                                    Number(5)
                                                )
                                            }
                                        }}
                                    >
                                        &pound;5M
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            className={`item-col-2 item-col-2__w58
                                ${!(extraInsuranceCover.employerLiabilityWageroll.check) ?
                                    `bottom-line` :
                                    `shadow`}`}
                        >
                            <div className="col1 col1__checkbox">
                                <Checkbox
                                    last={true}
                                    first={true}
                                    short={true}
                                    name="extraInsuranceCover.employerLiabilityWageroll.check"
                                    selected={extraInsuranceCover.employerLiabilityWageroll.check}
                                    onChange={this.handleCheckbox}
                                >
                                    Employer's Liability (£10M)
                                </Checkbox>
                            </div>
                            <div className="col2">
                                <div
                                    className={`input input__no-symbol ${
                                        !(extraInsuranceCover.employerLiabilityWageroll.check) ?
                                            `disabled` :
                                            ``}`}
                                    onClick={() =>
                                        this.inputClick('extraInsuranceCover.employerLiabilityWageroll.check')
                                    }
                                >
                                    <input
                                        type="number"
                                        disabled={!extraInsuranceCover.employerLiabilityWageroll.check}
                                        name="wageroll"
                                        onChange={
                                            (event) => {
                                                this.updateStateObject(
                                                    'extraInsuranceCover.' +
                                                    'employerLiabilityWageroll.value',
                                                    Number(event.target.value)
                                                )
                                            }
                                        }
                                        placeholder="Enter wageroll"
                                        min="0"
                                        step="any"
                                        value={extraInsuranceCover.employerLiabilityWageroll.value.toString()
                                            .replace(/^0+/, '')}
                                    />
                                </div>
                            </div>
                        </div>
                        <div
                            className={`item-col-2 item-col-2__w65 bottom-line
                            ${!(extraInsuranceCover.employerLiabilityWageroll.check) ?
                                    `hidden` :
                                    ``}`}
                        >
                            <div className="col1">
                                <div className="switchies">
                                    <div
                                        className={`switch
                                        ${(extraInsuranceCover.employerLiabilityType.selection === 'Enter ERN number') ?
                                                `selected` :
                                                ``}`}
                                        onClick={() => {
                                            this.changeSwitch(
                                                'extraInsuranceCover.employerLiabilityType.selection',
                                                'Enter ERN number'
                                            )
                                            this.updateStateObject(
                                                'extraInsuranceCover.employerLiabilityType.selection',
                                                'Enter ERN number'
                                            )
                                        }}
                                    >
                                        Enter ERN number
                                    </div>
                                    <div
                                        className={`switch
                                        ${(extraInsuranceCover.employerLiabilityType.selection === 'Client is exempt') ?
                                                `selected` :
                                                ``}`}
                                        onClick={() => {
                                            this.changeSwitch(
                                                'extraInsuranceCover.employerLiabilityType.selection',
                                                'Client is exempt'
                                            )
                                            this.updateStateObject(
                                                'extraInsuranceCover.employerLiabilityType.selection',
                                                'Client is exempt'
                                            )
                                        }}
                                    >
                                        Client is exempt
                                    </div>
                                    <div
                                        className={`switch
                                        ${(extraInsuranceCover.employerLiabilityType.selection === 'Unknown') ?
                                                `selected` :
                                                ``}`}
                                        onClick={() => {
                                            this.changeSwitch(
                                                'extraInsuranceCover.employerLiabilityType.selection',
                                                'Unknown'
                                            )
                                            this.updateStateObject(
                                                'extraInsuranceCover.employerLiabilityType.selection',
                                                'Unknown'
                                            )
                                        }}
                                    >
                                        Unknown
                                    </div>
                                </div>
                            </div>
                            <div className="col2">
                                <div className="input input__no-symbol">
                                    <input
                                        type="text"
                                        placeholder="Enter ERN Number"
                                        min="0"
                                        step="any"
                                        onChange={
                                            (event) => {
                                                this.updateStateObject(
                                                    'extraInsuranceCover.' +
                                                    'ernNumber.value',
                                                    event.target.value
                                                )
                                            }
                                        }
                                        value={extraInsuranceCover.ernNumber.value}
                                    />
                                </div>
                            </div>
                        </div>
                        <div
                            className={`item-col-2 item-col-2__w58 ${!(extraInsuranceCover.businessInterruption.check) ?
                                `bottom-line` :
                                `shadow`}`}
                        >
                            <div className="col1 col1__checkbox">
                                <Checkbox
                                    last={true}
                                    first={true}
                                    short={true}
                                    name="extraInsuranceCover.businessInterruption.check"
                                    selected={extraInsuranceCover.businessInterruption.check}
                                    onChange={this.handleCheckbox}
                                >
                                    Business interruption - loss of gross profit
                                </Checkbox>
                            </div>
                            <div className="col2">
                                <div
                                    className={`input input__no-symbol ${
                                        !(extraInsuranceCover.businessInterruption.check) ?
                                            `disabled` :
                                            ``}`}
                                    onClick={() =>
                                        this.inputClick('extraInsuranceCover.businessInterruption.check')
                                    }
                                >
                                    <input
                                        type="number"
                                        disabled={!extraInsuranceCover.businessInterruption.check}
                                        name="businessInterruption"
                                        onChange={
                                            (event) => {
                                                this.updateStateObject(
                                                    'extraInsuranceCover.' +
                                                    'businessInterruption.value',
                                                    Number(event.target.value)
                                                )
                                            }
                                        }
                                        placeholder="Enter gross profit"
                                        min="0"
                                        step="any"
                                        value={extraInsuranceCover.businessInterruption.value}
                                    />
                                </div>
                            </div>
                        </div>
                        <div
                            className={`item-col-1 bottom-line
                            ${!(extraInsuranceCover.businessInterruption.check) ?
                                    `hidden` :
                                    ``}`}
                        >
                            <div className="switchies">
                                <div
                                    className={`switch
                                    ${(extraInsuranceCover.businessInterruptionDuration.selection === 12) ?
                                            `selected` :
                                            ``}`}
                                    onClick={() => {
                                        this.changeSwitch(
                                            'extraInsuranceCover.businessInterruptionDuration.selection',
                                            12
                                        )
                                        this.updateStateObject(
                                            'extraInsuranceCover.businessInterruptionDuration.selection',
                                            12
                                        )
                                    }}
                                >
                                    12 months
                                </div>
                                <div
                                    className={`switch
                                    ${(extraInsuranceCover.businessInterruptionDuration.selection === 24) ?
                                            `selected` :
                                            ``}`}
                                    onClick={() => {
                                        this.changeSwitch(
                                            'extraInsuranceCover.businessInterruptionDuration.selection',
                                            24
                                        )
                                        this.updateStateObject(
                                            'extraInsuranceCover.businessInterruptionDuration.selection',
                                            24
                                        )
                                    }}
                                >
                                    24 months
                                </div>
                                <div
                                    className={`switch
                                    ${(extraInsuranceCover.businessInterruptionDuration.selection === 36) ?
                                            `selected` :
                                            ``}`}
                                    onClick={() => {
                                        this.changeSwitch(
                                            'extraInsuranceCover.businessInterruptionDuration.selection',
                                            36
                                        )
                                        this.updateStateObject(
                                            'extraInsuranceCover.businessInterruptionDuration.selection',
                                            36
                                        )
                                    }}
                                >
                                    36 months
                                </div>
                            </div>
                        </div>
                        <div className="item-col-2 item-col-2__w58 bottom-line">
                            <div className="col1 col1__checkbox">
                                <Checkbox
                                    last={true}
                                    first={true}
                                    short={true}
                                    name="extraInsuranceCover.aicow.check"
                                    selected={extraInsuranceCover.aicow.check}
                                    onChange={this.handleCheckbox}
                                >
                                    AICOW (12 months)
                                </Checkbox>
                                <ToolTip verticalPosition="top">
                                    Additional increased cost of working
                                </ToolTip>
                            </div>
                            <div className="col2">
                                <div
                                    className={`input ${!(extraInsuranceCover.aicow.check) ? `disabled` : ``}`}
                                    onClick={() =>
                                        this.inputClick('extraInsuranceCover.aicow.check')
                                    }
                                >
                                    <div className="pound">
                                        &pound;
                                    </div>
                                    <input
                                        name="outsideLimit"
                                        disabled={!extraInsuranceCover.aicow.check}
                                        placeholder="0"
                                        onChange={
                                            (event) => {
                                                this.updateStateObject(
                                                    'extraInsuranceCover.aicow.value',
                                                    Number(event.target.value)
                                                )
                                            }
                                        }
                                        type="number"
                                        min="0"
                                        step="any"
                                        value={extraInsuranceCover.aicow.value.toString().replace(/^0+/, '')}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="item-col-2 item-col-2__w58 shadow">
                            <div className="col1 col1__checkbox">
                                <Checkbox
                                    last={true}
                                    first={true}
                                    short={true}
                                    name="extraInsuranceCover.sicow.check"
                                    selected={extraInsuranceCover.sicow.check}
                                    onChange={this.handleCheckbox}
                                >
                                    SICOW (12 months)
                                </Checkbox>
                                <ToolTip verticalPosition="top">
                                    Standalone increased cost of working
                                </ToolTip>
                            </div>
                            <div className="col2">
                                <div
                                    className={`input ${!(extraInsuranceCover.sicow.check) ? `disabled` : ``}`}
                                    onClick={() =>
                                        this.inputClick('extraInsuranceCover.sicow.check')
                                    }
                                >
                                    <div className="pound">
                                        &pound;
                                    </div>
                                    <input
                                        name="outsideLimit"
                                        disabled={!extraInsuranceCover.sicow.check}
                                        placeholder="0"
                                        onChange={
                                            (event) => {
                                                this.updateStateObject(
                                                    'extraInsuranceCover.sicow.value',
                                                    Number(event.target.value)
                                                )
                                            }
                                        }
                                        type="number"
                                        min="0"
                                        step="any"
                                        value={extraInsuranceCover.sicow.value.toString().replace(/^0+/, '')}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    {this.props.editQuote && this.props.dirty ? (
                        <div className="quote__form__group quote__form__group--update">
                            <Button
                                type="submit"
                            >
                                Update
                            </Button>
                        </div>
                    ) : null}

                    <div className="quote__form__group quote__form__group--submit">
                        <Button
                            onClick={() => window.scrollTo(0, 0)}
                            type="submit"
                        >
                            Save and continue
                        </Button>
                    </div>
                </form >
            </div >
        )
    }
}

/**
 *     Formik Validation Struture
 */
const Step04Form = withFormik<any, any>({

    mapPropsToValues: (props: any) => ({
        outsideLimit:
            props.editQuote ? props.data.outsideLimit : Number(0),
        outsideLimitCheck:
            (props.editQuote && props.data.outsideLimit > 0) ? true : Boolean(false),
        sumInsured:
            props.editQuote ? props.data.sumInsured : Number(0),
        sumInsuredCheck:
            (props.editQuote && props.data.sumInsured > 0) ? true : Boolean(false),
        tradeFairsWithinUk:
            props.editQuote ? props.data.tradeFairsWithinUk : Number(0),
        tradeFairsOutsideUk:
            props.editQuote ? props.data.tradeFairsOutsideUk : Number(0),
        numberOfTradeFairs:
            props.editQuote ? props.data.numberOfTradeFairs : Number(0),
        buildings:
            props.editQuote ? props.data.buildings : Number(0),
        buildingsCheck:
            (props.editQuote && props.data.buildings > 0) ? true : false,
        officeContentsTenantsImprovements:
            props.editQuote ? props.data.officeContentsTenantsImprovements : Number(0),
        officeContentsTenantsImprovementsCheck:
            (props.editQuote && props.data.officeContentsTenantsImprovements > 0) ? true : Boolean(false),
        laptopsCamerasBusinessMachines:
            props.editQuote ? props.data.laptopsCamerasBusinessMachines : Number(0),
        laptopsCamerasBusinessMachinesCheck:
            (props.editQuote && props.data.laptopsCamerasBusinessMachines > 0) ? true : Boolean(false),
        staticComputerEquipment:
            props.editQuote ? props.data.staticComputerEquipment : Number(0),
        staticComputerEquipmentCheck:
            (props.editQuote && props.data.staticComputerEquipment > 0) ? true : Boolean(false),
        publicLiability:
            props.editQuote && props.data.publicLiability !== null ? props.data.publicLiability : Number(0),
        publicLiabilityCheck:
            (props.editQuote && props.data.publicLiability > 0) ? true : Boolean(false),
        employerLiabilityWageroll:
            props.editQuote ? props.data.employerLiabilityWageroll : Number(0),
        employerLiabilityWagerollCheck:
            (props.editQuote && props.data.employerLiabilityWageroll > 0) ? true : Boolean(false),
        employerLiabilityType:
            props.editQuote && props.data.employerLiabilityType !== null ?
                props.data.employerLiabilityType : 'Enter ERN number',
        ernNumber:
            props.editQuote && props.data.ernNumber !== null ? props.data.ernNumber : String(''),
        businessInterruption:
            props.editQuote ? props.data.businessInterruption : Number(0),
        businessInterruptionCheck:
            (props.editQuote && props.data.businessInterruption > 0) ? true : Boolean(false),
        businessInterruptionDuration:
            props.editQuote && props.data.businessInterruptionDuration !== null ?
                props.data.businessInterruptionDuration : Number(0),
        aicow:
            props.editQuote ? props.data.aicow : Number(0),
        aicowCheck:
            (props.editQuote && props.data.aicow > 0) ? true : Boolean(false),
        sicow:
            props.editQuote ? props.data.sicow : Number(0),
        sicowCheck:
            (props.editQuote && props.data.sicow > 0) ? true : Boolean(false),
        ukOutideAtLEastOne:
            props.editQuote ?
                props.data.tradeFairsWithinUk > 0 && props.data.tradeFairsOutsideUk > 0 ? 3 :
                    props.data.tradeFairsWithinUk === 0 && props.data.tradeFairsOutsideUk > 0 ? 2 :
                        props.data.tradeFairsWithinUk > 0 && props.data.tradeFairsOutsideUk === 0 ? 1 :
                            0 : 0,
    }),

    validationSchema: Yup.object().shape({
        outsideLimitCheck: Yup.boolean(),
        outsideLimit: Yup.number().when('outsideLimitCheck', {
            is: true,
            then: Yup.number().min(500, 'Outside limit must be greater than or equal to £500'),
            otherwise: Yup.number(),
        }),
        sumInsuredCheck: Yup.boolean(),
        sumInsured: Yup.number().when('sumInsuredCheck', {
            is: true,
            then: Yup.number().min(500, 'Trade Fairs must be greater than or equal to £500'),
            otherwise: Yup.number(),
        }),
        ukOutideAtLEastOne: Yup.number().when('sumInsuredCheck', {
            is: true,
            then: Yup.number().min(
                1,
                'Please enter annual aggregate estimates for the following trade fairs within/outside the UK'
            ),
            otherwise: Yup.number(),
        }),
        tradeFairsWithinUk: Yup.number().when(['sumInsuredCheck', 'ukOutideAtLEastOne'], {
            is: (sumInsuredCheck, ukOutideAtLEastOne) =>
                sumInsuredCheck && (ukOutideAtLEastOne === 1 || ukOutideAtLEastOne === 3),
            then: Yup.number().min(500, 'Trade Fairs within the UK must be greater than or equal to £500'),
            otherwise: Yup.number(),
        }),
        tradeFairsOutsideUk: Yup.number().when(['sumInsuredCheck', 'ukOutideAtLEastOne'], {
            is: (sumInsuredCheck, ukOutideAtLEastOne) =>
                sumInsuredCheck && (ukOutideAtLEastOne === 2 || ukOutideAtLEastOne === 3),
            then: Yup.number().min(500, 'Trade Fairs outside the UK must be greater than or equal to £500'),
            otherwise: Yup.number(),
        }),
        numberOfTradeFairs: Yup.number(),
        buildingsCheck: Yup.boolean(),
        buildings: Yup.number().when('buildingsCheck', {
            is: true,
            then: Yup.number().min(500, 'Buildings must be greater than or equal to £500'),
            otherwise: Yup.number(),
        }),
        officeContentsTenantsImprovementsCheck: Yup.boolean(),
        officeContentsTenantsImprovements: Yup.number().when('officeContentsTenantsImprovementsCheck', {
            is: true,
            then: Yup.number().min(500, 'Office contents & tenants improvements must be greater than or equal to £500'),
            otherwise: Yup.number(),
        }),
        laptopsCamerasBusinessMachinesCheck: Yup.boolean(),
        laptopsCamerasBusinessMachines: Yup.number().when('laptopsCamerasBusinessMachinesCheck', {
            is: true,
            then: Yup.number().min(500, 'Laptops / cameras / business machines must be greater than or equal to £500'),
            otherwise: Yup.number(),
        }),
        staticComputerEquipmentCheck: Yup.boolean(),
        staticComputerEquipment: Yup.number().when('staticComputerEquipmentCheck', {
            is: true,
            then: Yup.number().min(500, 'Static computer equipment must be greater than or equal to £500'),
            otherwise: Yup.number(),
        }),
        publicLiability: Yup.number(),
        employerLiabilityWagerollCheck: Yup.boolean(),
        employerLiabilityWageroll: Yup.number().when('employerLiabilityWagerollCheck', {
            is: true,
            then: Yup.number().min(1, 'Wageroll is required').required('Wageroll is required.'),
            otherwise: Yup.number(),
        }),
        employerLiabilityType: Yup.string(),
        ernNumber: Yup.string(),
        businessInterruption: Yup.number(),
        businessInterruptionDuration: Yup.number(),
        aicowCheck: Yup.boolean(),
        aicow: Yup.number().when('aicowCheck', {
            is: true,
            then: Yup.number().min(500, 'AICOW must be greater than or equal to £500'),
            otherwise: Yup.number(),
        }),
        sicowCheck: Yup.boolean(),
        sicow: Yup.number().when('sicowCheck', {
            is: true,
            then: Yup.number().min(500, 'SICOW must be greater than or equal to £500'),
            otherwise: Yup.number(),
        }),
    }),

    handleSubmit: (values, { props, setSubmitting, resetForm }) => {
        let content = {
            'quote': {
                'id': props.editRenewal ? props.renewalQuoteId : props.match.params.id,
                'additionalCover': {
                    'outsideLimit': values.outsideLimitCheck ? values.outsideLimit : Number(0),
                    'sumInsured': values.sumInsuredCheck ? values.sumInsured : Number(0),
                    'tradeFairsWithinUk': values.sumInsuredCheck ? values.tradeFairsWithinUk : Number(0),
                    'tradeFairsOutsideUk': values.sumInsuredCheck ? values.tradeFairsOutsideUk : Number(0),
                    'numberOfTradeFairs': values.sumInsuredCheck ? values.numberOfTradeFairs : Number(0),
                    'buildings': values.buildingsCheck ? values.buildings : Number(0),
                    'officeContentsTenantsImprovements': values.officeContentsTenantsImprovementsCheck ?
                        values.officeContentsTenantsImprovements :
                        Number(0),
                    'laptopsCamerasBusinessMachines': values.laptopsCamerasBusinessMachinesCheck ?
                        values.laptopsCamerasBusinessMachines :
                        Number(0),
                    'staticComputerEquipment': values.staticComputerEquipmentCheck ?
                        values.staticComputerEquipment :
                        Number(0),
                    'publicLiability': values.publicLiabilityCheck ? values.publicLiability : null,
                    'employerLiabilityWageroll': values.employerLiabilityWagerollCheck ?
                        values.employerLiabilityWageroll :
                        Number(0),
                    'employerLiabilityType': values.employerLiabilityWagerollCheck ?
                        values.employerLiabilityType :
                        null,
                    'ernNumber': values.employerLiabilityWagerollCheck ?
                        values.ernNumber :
                        null,
                    'businessInterruption': values.businessInterruptionCheck ? values.businessInterruption : Number(0),
                    'businessInterruptionDuration': values.businessInterruptionCheck ?
                        values.businessInterruptionDuration :
                        null,
                    'aicow': values.aicowCheck ? values.aicow : Number(0),
                    'sicow': values.sicowCheck ? values.sicow : Number(0),
                },
            },
        }

        if (props.mta) {
            props.updateData(content)
            resetForm(content)
        } else {
            if (props.editRenewal) {
                props.setStep04Renewals(content).finally(() => {
                    props.checkStep04update()
                    props.getRenewalVariation(props.renewalQuoteId).finally(() => {
                        resetForm(content)
                    })
                })
            } else {
                props.setStep04(content)
                resetForm(content)
            }
        }
        // resetForm(content)

        if (props.editQuote) {
            setTimeout(props.update, 500)
        }
    },

})(Step04FormHTML)

export default Step04Form



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Quote/Step04/Step04.tsx